import type { JSX } from "preact";

type IconProps = JSX.SVGAttributes<SVGSVGElement>;

export function IcoSquare({ class: className, ...props }: IconProps) {
  return (
    <svg
      class={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="1.5"
      aria-hidden="true"
      {...props}
    >
      <rect x="4" y="4" width="16" height="16" rx="2" />
    </svg>
  );
}
